<!-- 弹窗组件 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">样式设置</MenuItem>
                <MenuItem name="2" class="head-text">内容设置</MenuItem>
                <MenuItem name="3" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <div v-if="name_id == 1">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title mt24">样式设置</div>
                        <FormItem label="弹框样式">
                            <RadioGroup
                                v-model="newFormData.content.style_value"
                            >
                                <Radio class="mr24" label="1">弹框</Radio>
                                <Radio class="mr24" label="2">全屏广告</Radio>
                            </RadioGroup>
                        </FormItem>
                        <!-- 弹框 -->
                        <template v-if="newFormData.content.style_value == 1">
                            <div class="form-title mt24">关闭设置</div>
                            <FormItem label="关闭方式">
                                <RadioGroup
                                    v-model="newFormData.content.cancel_value1"
                                >
                                    <Radio class="mr24" label="1">无</Radio>
                                    <Radio class="mr24" label="2">按钮</Radio>
                                    <Radio class="mr24" label="3">默认</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem
                                v-if="newFormData.content.cancel_value1 == 2"
                                label="位置"
                            >
                                <RadioGroup
                                    v-model="
                                        newFormData.content
                                            .cancel_position_value1
                                    "
                                >
                                    <Radio class="mr24" label="1">右上</Radio>
                                    <Radio class="mr24" label="2">正下</Radio>
                                    <Radio class="mr24" label="3">正上</Radio>
                                </RadioGroup>
                            </FormItem>
                        </template>
                        <!-- 全屏广告 -->
                        <template v-if="newFormData.content.style_value == 2">
                            <div class="form-title mt24">关闭设置</div>
                            <FormItem label="关闭方式">
                                <RadioGroup
                                    v-model="newFormData.content.cancel_value2"
                                >
                                    <Radio class="mr24" label="1">无</Radio>
                                    <Radio class="mr24" label="2">按钮</Radio>
                                    <Radio class="mr24" label="3">倒计时</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem
                                v-if="
                                    newFormData.content.cancel_value2 == 2 ||
                                    newFormData.content.cancel_value2 == 3
                                "
                                label="位置"
                            >
                                <RadioGroup
                                    v-model="
                                        newFormData.content
                                            .cancel_position_value2
                                    "
                                >
                                    <Radio class="mr24" label="1">左上</Radio>
                                    <Radio class="mr24" label="2">右上</Radio>
                                    <Radio class="mr24" label="3">左下</Radio>
                                    <Radio class="mr24" label="4">右下</Radio>
                                </RadioGroup>
                            </FormItem>
                            <template
                                v-if="newFormData.content.cancel_value2 == 3"
                            >
                                <FormItem label="倒计时">
                                    <InputNumber
                                        class="w100"
                                        :max="59"
                                        :min="1"
                                        v-model="newFormData.content.countdown"
                                        placeholder="请输入倒计时（最大值为59即一分钟）"
                                    ></InputNumber>
                                </FormItem>
                                <FormItem label="按钮背景">
                                    <ColorPicker
                                        v-model="
                                            newFormData.content
                                                .countdown_bg_color
                                        "
                                    />
                                </FormItem>
                                <FormItem label="透明度">
                                    <Input
                                        v-model="
                                            newFormData.content
                                                .countdown_opacity
                                        "
                                        placeholder="请输入透明度"
                                    >
                                        <span slot="append">%</span>
                                    </Input>
                                </FormItem>
                                <FormItem label="文字颜色">
                                    <ColorPicker
                                        v-model="
                                            newFormData.content
                                                .countdown_text_color
                                        "
                                    />
                                </FormItem>
                            </template>
                        </template>
                        <div class="form-title mt24">背景设置</div>
                        <FormItem
                            v-if="newFormData.content.style_value == 1"
                            label="背景高度"
                        >
                            <Input
                                v-model="newFormData.content.bg_height"
                                placeholder="请输入背景高度"
                                ><span slot="append">PX</span></Input
                            >
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.style_value == 1"
                            label="背景宽度"
                        >
                            <Input
                                v-model="newFormData.content.bg_width"
                                placeholder="请输入背景宽度"
                                ><span slot="append">PX</span></Input
                            >
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.style_value == 1"
                            label="背景颜色"
                            ><ColorPicker
                                v-model="newFormData.content.bg_color"
                                @on-change="changeBgColor"
                        /></FormItem>
                        <FormItem
                            v-if="newFormData.content.style_value == 1"
                            label="背景图"
                        >
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="
                                newFormData.content.bg_value ||
                                newFormData.content.style_value == 2
                            "
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div v-if="newFormData.content.style_value == 1">
                            <div class="form-title mt24">标题设置</div>
                            <FormItem label="弹框标题"
                                ><Input
                                    v-model="newFormData.content.title"
                                    placeholder="请输入弹框标题"
                                ></Input
                            ></FormItem>
                            <FormItem label="标题大小"
                                ><Input
                                    v-model="newFormData.content.title_size"
                                    placeholder="请输入标题大小"
                                    ><span slot="append">PX</span></Input
                                ></FormItem
                            >
                            <FormItem label="标题颜色"
                                ><ColorPicker
                                    v-model="newFormData.content.title_color"
                            /></FormItem>
                            <div class="form-title mt24">内容设置</div>
                            <FormItem label="弹框内容"
                                ><Input
                                    v-model="newFormData.content.text"
                                    type="textarea"
                                    placeholder="请输入弹框内容"
                                ></Input
                            ></FormItem>
                            <FormItem label="内容大小"
                                ><Input
                                    v-model="newFormData.content.text_size"
                                    placeholder="内容大小"
                                    ><span slot="append">PX</span></Input
                                ></FormItem
                            >
                            <FormItem label="文字位置">
                                <RadioGroup
                                    v-model="newFormData.content.text_position"
                                    type="button"
                                >
                                    <Radio label="left"
                                        ><Icon type="md-menu"
                                    /></Radio>
                                    <Radio label="center"
                                        ><Icon type="md-funnel"
                                    /></Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem label="内容颜色"
                                ><ColorPicker
                                    v-model="newFormData.content.text_color"
                            /></FormItem>
                        </div>
                        <div class="form-title mt24">按钮设置</div>
                        <FormItem label="按钮设置">
                            <RadioGroup v-model="newFormData.content.btn_value">
                                <Radio class="mr24" label="1">无</Radio>
                                <Radio class="mr24" label="2">单按钮</Radio>
                                <Radio class="mr24" label="3">双按钮</Radio>
                            </RadioGroup>
                        </FormItem>
                        <div
                            v-if="
                                newFormData.content.btn_value == 2 ||
                                newFormData.content.btn_value == 3
                            "
                            class="btn-view"
                        >
                            <div class="btn-view">
                                <FormItem label="按钮文字">
                                    <Input
                                        v-model="newFormData.content.btn_text"
                                        placeholder="请输入按钮文字"
                                    ></Input>
                                </FormItem>
                                <FormItem label="文字颜色">
                                    <ColorPicker
                                        v-model="newFormData.content.txt_color"
                                    />
                                </FormItem>
                                <FormItem label="按钮背景">
                                    <ColorPicker
                                        v-model="
                                            newFormData.content.btn_bg_color
                                        "
                                    />
                                </FormItem>
                                <FormItem label="按钮边框">
                                    <ColorPicker
                                        v-model="
                                            newFormData.content.btn_border_color
                                        "
                                    />
                                </FormItem>
                                <Select
                                    class="mt-6"
                                    v-model="newFormData.content.action_id"
                                    filterable
                                    placeholder="跳转动作"
                                >
                                    <Option
                                        v-for="item in actionList2"
                                        :value="item.id"
                                        :key="item.id"
                                        >{{ item.name }}</Option
                                    >
                                </Select>
                                <Input
                                    class="mt-6"
                                    v-if="newFormData.content.action_id == 1"
                                    v-model="newFormData.content.link_name"
                                    placeholder="请输入外部链接（http/https）"
                                ></Input>
                                <Select
                                    class="mt-6"
                                    v-if="newFormData.content.action_id == 2"
                                    v-model="newFormData.content.link_id"
                                    filterable
                                    placeholder="请选择跳转页面"
                                >
                                    <Option
                                        v-for="item in linkList"
                                        :value="item.id"
                                        :key="item.id"
                                        >{{ item.title }}</Option
                                    >
                                </Select>
                            </div>
                            <div
                                class="btn-view2"
                                v-if="newFormData.content.btn_value == 3"
                            >
                                <FormItem label="按钮文字">
                                    <Input
                                        v-model="newFormData.content.btn_text2"
                                        placeholder="请输入按钮文字"
                                    ></Input>
                                </FormItem>
                                <FormItem label="文字颜色">
                                    <ColorPicker
                                        v-model="newFormData.content.txt_color2"
                                    />
                                </FormItem>
                                <FormItem label="按钮背景">
                                    <ColorPicker
                                        v-model="
                                            newFormData.content.btn_bg_color2
                                        "
                                    />
                                </FormItem>
                                <FormItem label="按钮边框">
                                    <ColorPicker
                                        v-model="
                                            newFormData.content
                                                .btn_border_color2
                                        "
                                    />
                                </FormItem>
                                <Select
                                    class="mt-6"
                                    v-model="newFormData.content.action_id2"
                                    filterable
                                    placeholder="跳转动作"
                                >
                                    <Option
                                        v-for="item in actionList2"
                                        :value="item.id"
                                        :key="item.id"
                                        >{{ item.name }}</Option
                                    >
                                </Select>
                                <Input
                                    class="mt-6"
                                    v-if="newFormData.content.action_id2 == 1"
                                    v-model="newFormData.content.link_name2"
                                    placeholder="请输入外部链接（http/https）"
                                ></Input>
                                <Select
                                    class="mt-6"
                                    v-if="newFormData.content.action_id2 == 2"
                                    v-model="newFormData.content.link_id2"
                                    filterable
                                    placeholder="请选择跳转页面"
                                >
                                    <Option
                                        v-for="item in linkList"
                                        :value="item.id"
                                        :key="item.id"
                                        >{{ item.title }}</Option
                                    >
                                </Select>
                            </div>
                        </div>
                    </Form>
                </div>
                <div v-if="name_id == 3">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div
                            v-if="newFormData.content.style_value == 1"
                            class="form-title"
                        >
                            圆角设置
                        </div>
                        <FormItem
                            v-if="newFormData.content.style_value == 1"
                            label="上圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem
                            v-if="newFormData.content.style_value == 1"
                            label="下圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.bottom"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">按钮设置</div>
                        <FormItem label="左右边距"
                            ><Slider
                                v-if="newFormData.content.btnData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.btnData.left"
                            ></Slider
                        ></FormItem>
                        <FormItem label="圆角"
                            ><Slider
                                v-if="newFormData.content.btnData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.btnData.radius"
                            ></Slider
                        ></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        diy_id: {
            type: String,
            default: "0",
        },
        newFormData: {
            type: Object,
            default: {},
        },
        linkList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            actionList2: [],
        };
    },
    mounted() {
        if (this.diy_id == 1) {
            this.actionList2 = [
                { id: 1, name: "跳转外部链接" },
                { id: 2, name: "跳转页面" },
                { id: 3, name: "扫一扫" },
                { id: 4, name: "关闭弹窗" },
            ];
        } else if (this.diy_id == 2) {
            this.actionList2 = [
                { id: 1, name: "跳转外部链接" },
                { id: 3, name: "扫一扫" },
                { id: 4, name: "关闭弹窗" },
            ];
        }
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        // 背景颜色 - 必填
        changeBgColor(e) {
            if (!e) {
                this.$Message.error("背景颜色必填");
                this.newFormData.content.bg_color = "#fff";
            }
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.btn-view2 {
    padding: 12px;
    margin: 12px 0 0 0;
    border: 1px solid #ccc;
}
.btn-view {
    padding: 12px;
    border: 1px solid #ccc;
}
.mt-6 {
    margin: 6px 0 0 0;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
.w100 {
    width: 100% !important;
}
</style>